<script setup lang="ts">
// Formkit schema: https://formkit.com/api-reference/formkit-inputs#formkitschemaextendablesection
import type { UmbracoFormField } from 'types/blocks';

const FormFieldCheckBox = resolveComponent('LazyPartialsFormFieldCheckBox');
const FormFieldDropDownList = resolveComponent('LazyPartialsFormFieldDropDownList');
const FormFieldEmail = resolveComponent('LazyPartialsFormFieldEmail');
const FormFieldNumber = resolveComponent('LazyPartialsFormFieldNumber');
const FormFieldPhone = resolveComponent('LazyPartialsFormFieldPhone');
const FormFieldRadioButtonList = resolveComponent('LazyPartialsFormFieldRadioButtonList');
const FormFieldText = resolveComponent('LazyPartialsFormFieldText');
const FormFieldTextArea = resolveComponent('LazyPartialsFormFieldTextArea');

const props = defineProps<{
  field: UmbracoFormField;
}>();

const fieldTemplate = computed(() => {
  let field = null;

  if (!props.field.type) {
    return field;
  }

  const type = props.field.type;
  const fieldType = props.field.settings.fieldType;

  if (type === 'dropdownlist' && props.field.preValues.length > 0) {
    field = FormFieldDropDownList;
  }

  if (type === 'checkbox' || type === 'dataconsent') {
    field = FormFieldCheckBox;
  }

  if (type === 'textfield' && fieldType === 'number') {
    field = FormFieldNumber;
  }

  if (type === 'textfield' && (fieldType === 'text' || fieldType === '')) {
    field = FormFieldText;
  }

  if (type === 'textfield' && fieldType === 'tel') {
    field = FormFieldPhone;
  }

  if (type === 'textfield' && fieldType === 'email') {
    field = FormFieldEmail;
  }

  if (type === 'textarea') {
    field = FormFieldTextArea;
  }

  if (type === 'radiobuttonlist') {
    field = FormFieldRadioButtonList;
  }

  if (field === null) {
    const loggingService = useLoggingService();
    loggingService.error('Form field type not recognised!');
  }

  return field;
});
</script>

<template>
  <Component
    :is="fieldTemplate"
    v-if="fieldTemplate"
    :field="props.field"
  />
</template>
